import Markdown from 'react-markdown';
import config from './config';
import {useWorkspaceContext} from '../../../context/workspaceContext';

function NodeHyperlink(props) {
    const {  children } = props;
    const { customStyles } = config;
    const linkColor = customStyles?.botMessageBox?.textColor || '#000';
    const { canvasSearchFunction, canvasNavigateFunction} = useWorkspaceContext();

    

    const searchNode = (searchText) => {
        let results = canvasSearchFunction ? canvasSearchFunction(searchText) : [];
        if (results.length > 0 && canvasNavigateFunction) {
            canvasNavigateFunction(results[0].id);
        }
    }

    return (
        <a style={{ color: linkColor }} onClick={(event) => {
            event.stopPropagation();
            searchNode(children)
        }} >
            {children}
        </a>
    );
}

export default function BotChatMessage({ message }) {
    const bg = config?.customStyles?.botMessageBox?.backgroundColor;

    return (
        <div className="react-chatbot-kit-chat-bot-message" style={{ backgroundColor: bg }}>
            <Markdown
                components={{
                    a(props) {
                        return <NodeHyperlink {...props} />;
                    }
                }}
            >{message}</Markdown>
            <div className='react-chatbot-kit-chat-bot-message-arrow' style={{borderRightColor: bg}}></div>
        </div>
    );
}